// import { defaultNetworkService } from '../../../../../services/network'
import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const UPDATE_ALL_DATA = "saga/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE";
export const FETCH_NEW_MEMBERSHIPS = "saga/FETCH_NEW_MEMBERSHIPS";
export const FETCH_NEW_MEMBERSHIPS_SUCCESS = "saga/FETCH_NEW_MEMBERSHIPS_SUCCESS";
export const FETCH_NEW_MEMBERSHIPS_FAILURE = "saga/FETCH_NEW_MEMBERSHIPS_FAILURE";
export const FETCH_NEW_MEMBERSHIPS_EXPIRING = "saga/FETCH_NEW_MEMBERSHIPS_EXPIRING";
export const FETCH_NEW_MEMBERSHIPS_EXPIRING_SUCCESS = "saga/FETCH_NEW_MEMBERSHIPS_EXPIRING_SUCCESS";
export const FETCH_NEW_MEMBERSHIPS_EXPIRING_FAILURE = "saga/FETCH_NEW_MEMBERSHIPS_EXPIRING_FAILURE";
export const FETCH_EXPIRED_MEMBERSHIPS = "saga/FETCH_EXPIRED_MEMBERSHIPS";
export const FETCH_EXPIRED_MEMBERSHIPS_SUCCESS = "saga/FETCH_EXPIRED_MEMBERSHIPS_SUCCESS";
export const FETCH_EXPIRED_MEMBERSHIPS_FAILURE = "saga/FETCH_EXPIRED_MEMBERSHIPS_FAILURE";
export const FETCH_MEMBERSHIPS_SOLD = "saga/FETCH_MEMBERSHIPS_SOLD";
export const FETCH_MEMBERSHIPS_SOLD_SUCCESS = "saga/FETCH_MEMBERSHIPS_SOLD_SUCCESS";
export const FETCH_MEMBERSHIPS_SOLD_FAILURE = "saga/FETCH_MEMBERSHIPS_SOLD_FAILURE";
export const FETCH_MEMBERS_AT_RISK = "saga/FETCH_MEMBERS_AT_RISK";
export const FETCH_MEMBERS_AT_RISK_SUCCESS = "saga/FETCH_MEMBERS_AT_RISK_SUCCESS";
export const FETCH_MEMBERS_AT_RISK_FAILURE = "saga/FETCH_MEMBERS_AT_RISK_FAILURE";
export const FETCH_TOTAL_ACTIVE_MEMBERS = "saga/FETCH_TOTAL_ACTIVE_MEMBERS";
export const FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS = "saga/FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS";
export const FETCH_TOTAL_ACTIVE_MEMBERS_FAILURE = "saga/FETCH_TOTAL_ACTIVE_MEMBERS_FAILURE";
export const FETCH_ZERO_VISITS_MEMBERS = "saga/FETCH_ZERO_VISITS_MEMBERS";
export const FETCH_ZERO_VISITS_MEMBERS_SUCCESS = "saga/FETCH_ZERO_VISITS_MEMBERS_SUCCESS";
export const FETCH_ZERO_VISITS_MEMBERS_FAILURE = "saga/FETCH_ZERO_VISITS_MEMBERS_FAILURE";
export const FETCH_FROZEN_MEMBERS = "saga/FETCH_FROZEN_MEMBERS";
export const FETCH_FROZEN_MEMBERS_SUCCESS = "saga/FETCH_FROZEN_MEMBERS_SUCCESS";
export const FETCH_FROZEN_MEMBERS_FAILURE = "saga/FETCH_FROZEN_MEMBERS_FAILURE";
export const FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE = "saga/FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE";
export const FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS = "saga/FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS";
export const FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_FAILURE = "saga/FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_FAILURE";
// const axios = defaultNetworkService()

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  fetchNewMemberships: createAction(FETCH_NEW_MEMBERSHIPS),
  fetchNewMembershipsExpiring: createAction(FETCH_NEW_MEMBERSHIPS_EXPIRING),
  fetchExpiredMemberships: createAction(FETCH_EXPIRED_MEMBERSHIPS),
  fetchMembershipsSold: createAction(FETCH_MEMBERSHIPS_SOLD),
  fetchMembersAtRisk: createAction(FETCH_MEMBERS_AT_RISK),
  fetchTotalActiveMembers: createAction(FETCH_TOTAL_ACTIVE_MEMBERS),
  fetchZeroVisitsMembers: createAction(FETCH_ZERO_VISITS_MEMBERS)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
  yield takeLatest(FETCH_NEW_MEMBERSHIPS, getNewMemberships);
  yield takeLatest(FETCH_NEW_MEMBERSHIPS_EXPIRING, getNewMembershipsExpiringData);
  yield takeLatest(FETCH_EXPIRED_MEMBERSHIPS, getExpiredMembershipsData);
  yield takeLatest(FETCH_MEMBERSHIPS_SOLD, getNewMembershipsSoldData);
  yield takeLatest(FETCH_MEMBERS_AT_RISK, getAtRiskMembersData);
  yield takeLatest(FETCH_TOTAL_ACTIVE_MEMBERS, getTotalActiveMembersData);
  yield takeLatest(FETCH_ZERO_VISITS_MEMBERS, getZeroVisitsMembersData);
}

export function* getCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });

  // Pass user props from rails to redux
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload.user });

  let date = data.payload.date || (yield select(state => state.membership.currentUser.calendarEndDate));
  let id = yield select(state => state.membership.currentUser.organization_id);
  let objectId = yield select(state => state.membership.currentUser.current_object_id);
  let locationId = yield select(state => state.membership.currentUser.current_location_id);
  let regionId = yield select(state => state.membership.currentUser.current_region_id);

  let allSagas = [
    getNewMemberships(id, objectId, locationId, regionId, date),
    getNewMembershipsSoldData(id, objectId, locationId, regionId, date),
    getAtRiskMembersData(id, objectId, locationId, regionId, date),
    getTotalActiveMembersData(id, objectId, locationId, regionId, date),
    getZeroVisitsMembersData(id, objectId, locationId, regionId, date),
    getYearOverYearMembershipRevenue(id, objectId, locationId, regionId, date),
    getTotalFrozenMembers(id, objectId, locationId, regionId, date)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData(month) {
  yield put({ type: SET_LOADING, payload: true });

  let date = month.payload;
  let id = yield select(state => state.membership.currentUser.organization_id);
  let objectId = yield select(state => state.membership.currentUser.current_object_id);
  let locationId = yield select(state => state.membership.currentUser.current_location_id);
  let regionId = yield select(state => state.membership.currentUser.current_region_id);

  let allSagas = [
    getNewMemberships(id, objectId, locationId, regionId, date),
    getNewMembershipsSoldData(id, objectId, locationId, regionId, date),
    getAtRiskMembersData(id, objectId, locationId, regionId, date),
    getTotalActiveMembersData(id, objectId, locationId, regionId, date),
    getZeroVisitsMembersData(id, objectId, locationId, regionId, date),
    getYearOverYearMembershipRevenue(id, objectId, locationId, regionId, date),
    getTotalFrozenMembers(id, objectId, locationId, regionId, date)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getNewMemberships(id, objectId, locationId, regionId, date) {
  try {
    const newMembershipsResponse = yield call(axios.get, queryParams.apiVersion + "membership/new_memberships", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_NEW_MEMBERSHIPS_SUCCESS, payload: newMembershipsResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_NEW_MEMBERSHIPS_FAILURE, error });
  }
}

export function* getNewMembershipsExpiringData(id, objectId, locationId, regionId, date) {
  try {
    const newMembershipsExpiringResponse = yield call(axios.get, queryParams.apiVersion + "membership/memberships_expiring_soon", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_NEW_MEMBERSHIPS_EXPIRING_SUCCESS, payload: newMembershipsExpiringResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_NEW_MEMBERSHIPS_EXPIRING_FAILURE, error });
  }
}

export function* getExpiredMembershipsData(id, objectId, locationId, regionId, date) {
  try {
    const expiredMembershipsResponse = yield call(axios.get, queryParams.apiVersion + "membership/expired_memberships", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_EXPIRED_MEMBERSHIPS_SUCCESS, payload: expiredMembershipsResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_EXPIRED_MEMBERSHIPS_FAILURE, error });
  }
}

export function* getNewMembershipsSoldData(id, objectId, locationId, regionId, date) {
  try {
    const newMembershipsSoldResponse = yield call(axios.get, queryParams.apiVersion + "membership/membership_sales", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_MEMBERSHIPS_SOLD_SUCCESS, payload: newMembershipsSoldResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIPS_SOLD_FAILURE, error });
  }
}

export function* getAtRiskMembersData(id, objectId, locationId, regionId, date) {
  try {
    const atRiskMembersResponse = yield call(axios.get, queryParams.apiVersion + "membership/members_at_risk", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_MEMBERS_AT_RISK_SUCCESS, payload: atRiskMembersResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERS_AT_RISK_FAILURE, error });
  }
}

export function* getTotalActiveMembersData(id, objectId, locationId, regionId, date) {
  try {
    const totalActiveMembersResponse = yield call(axios.get, queryParams.apiVersion + "membership/total_active_members", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS, payload: totalActiveMembersResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_TOTAL_ACTIVE_MEMBERS_FAILURE, error });
  }
}

export function* getZeroVisitsMembersData(id, objectId, locationId, regionId, date) {
  try {
    const zeroVisitsMembersResponse = yield call(axios.get, queryParams.apiVersion + "membership/zero_visits_members", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_ZERO_VISITS_MEMBERS_SUCCESS, payload: zeroVisitsMembersResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_ZERO_VISITS_MEMBERS_FAILURE, error });
  }
}

export function* getTotalFrozenMembers(id, objectId, locationId, regionId, date) {
  try {
    const res = yield call(axios.get, queryParams.apiVersion + "membership/total_frozen_members", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_FROZEN_MEMBERS_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FROZEN_MEMBERS_FAILURE, error });
  }
}

export function* getYearOverYearMembershipRevenue(id, objectId, locationId, regionId, date) {
  try {
    const response = yield call(axios.get, queryParams.apiVersion + "membership/year_over_year_membership_revenues", {
      params: {
        organization_id: id,
        location_id: locationId,
        region_id: regionId,
        object_id: objectId,
        date: date
      }
    });
    yield put({ type: FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_FAILURE, error });
  }
}
